export default __webpack_public_path__ + "static/media/back-arrow.56e2a63a.svg";